import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// MUI Imports
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
  Paper,
  Card,
  IconButton,
  CardContent,
  ThemeProvider,
  Tooltip,
} from "@mui/material";

// Other Imports
import ArchiveIcon from "@mui/icons-material/Archive";
import MUIDataTable from "mui-datatables";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay-ts";

// Project Imports
import {
  fetchTrainers,
  restoreTrainerInitial,
  fetchAllTotalTrainersDetails,
  emptyTrainerSelect,
  saveCurrentTrainerId,
  exportVirtuallyApprovedTrainers,
} from "../../../Actions";
import Page from "../../../Components/Dashboard/Page";
import DialogBox from "../../../Components/DialogBox/DialogBox";
import ConfirmDialog from "../../../Components/Alert/ConfirmDialog";
import { colors } from "../../../../src/Styles/GlobalStyles/Variables";
import "../../../../src/Pages/HQAdminPortal/Routes/Dashboard/MuiTable.scss";
import StatusGenerator from "../../../Components/StatusGenerator/StatusGenerator";
import { ViewIcon } from "../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import { MuiDataTableTheme } from "../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import { EmptyRowIcon } from "../../../Components/Icons/EmptyRowIcon";
import Searchbox from "../../../Components/Dashboard/Searchbox";
import TrainersPrintTemplate from "../../../Components/PrintFiles/TrainersPrintTemplate";
import { clearMsg, infoMsg } from "../../../Utils/apiToasts";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";

const getTrainerState = (state) => state.trainersReducer;

LoadingOverlay.propTypes = undefined;

export const DownloadIcon = () => {

  const {
    exportingVirtuallyApprovedTrainers,
  } = useSelector(getTrainerState);

  if (exportingVirtuallyApprovedTrainers) {
    return <CircularProgress size={20} />;
  } else {
    return <CloudDownloadOutlinedIcon />;
  }
};

const VirtualApproval = () => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState({
    open: false,
    Title: "",
    Content: null,
    actionButton: "",
  });

  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const { trainerSelectFetched, isFetched } = useSelector(getTrainerState);
  const [openNewTrainerDialog, setOpenNewTrainerDialog] = useState(false);
  const [openViewTrainerDialog, setOpenViewTrainerDialog] = useState(false);
  const [trainersTableData, setTrainersTableData] = useState([]);
  const [loading, setloading] = useState(true);
  const [showNoDataMessage, setShowNoDataMessage] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;
  const [searchText, setSearchText] = useState("");
  const [filterOptions, setFilterOptions] = useState({
    IsVirtualApproval: true,
  });
  const [filters, setFilters] = useState("");
  const [resetState, setResetState] = useState(false);

  const dispatch = useDispatch();
  const {
    trainersFetched,
    trainerActivated,
    trainerUpdated,
    trainerDeactivated,
    isLoading,
    totalTrainerCount,
    exportingVirtuallyApprovedTrainers,
    // exportVirtuallyApprovedTrainersSuccess,
  } = useSelector(getTrainerState);

  // const [notify, setNotify] = useState({
  //   isOpen: false,
  //   message: "",
  //   type: "",
  // });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    isLoading: false,
    title: "",
    subTitle: "",
    header: "",
    backgroundColor: "",
    borderSideColor: "",
    color: "",
    subColor: "",
  });

  const ColumnTextStyle = {
    textTransform: "capitalize",
    textAlign: "left",
    color: "#212b36",
    fontSize: "0.875rem",
    fontWeight: 600,
  };

  const ToastStyle = {
    backgroundColor: colors.primaryGreen,
    color: colors.white,
  };

  const printIdCardArea = () => {
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.srcdoc = document.getElementById("printarea").innerHTML;
    document.body.appendChild(iframe);
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    iframe.contentWindow.close();
    iframe.style.display = "none";
    clearMsg();
  };

  useEffect(() => {
    if (showPrintPreview && trainerSelectFetched.length > 0) {
      clearMsg("");
      printIdCardArea();
    } else if (showPrintPreview && trainerSelectFetched.length < 0) {
      infoMsg("Loading the print preview window...");
    }
  }, [showPrintPreview, trainerSelectFetched]);

  useEffect(() => {
    if (isFetched && showPrintPreview) {
      setShowPrintPreview(false);
      dispatch(emptyTrainerSelect());
    }
  }, [isFetched, showPrintPreview, dispatch]);

  // const handleOpenNewTrainerDialog = () => {
  //   setOpenNewTrainerDialog(true);
  //   dispatch(fetchStates());
  //   dispatch(fetchSkillSelect());
  //   setResetState(false);
  // };

  // const handleOpenViewTrainerDialog = (id) => {
  //   setFormType("view");
  //   setOpenViewTrainerDialog(true);
  //   dispatch(fetchTrainerById(id));
  //   //history.push(`/ApproveTrainer/${id}`);
  // };
  // const handleOpenEditTrainerDialog = (id) => {
  //   setFormType("edit");
  //   setOpenViewTrainerDialog(true);
  //   dispatch(fetchTrainerById(id));
  //   dispatch(fetchSkillSelect());
  //   dispatch(fetchStates());
  //   dispatch(fetchSkillCentreByStateId(id));
  // };

  // const handleOpenEditDialog = (id) => {
  //   setFormType("edit");
  // };
  const handleCloseNewTrainerDialog = () => {
    let params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
    };
    setOpenNewTrainerDialog(false);
    dispatch(fetchAllTotalTrainersDetails());
    dispatch(fetchTrainers(params));
    setResetState(true);
  };
  const handleCloseViewTrainerDialog = () => {
    let params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
    };
    setOpenViewTrainerDialog(false);
    dispatch(fetchTrainers(params));
  };

  useEffect(() => {
    if (trainerActivated === true) {
      setloading(true);
      let params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: searchText,
        FilterOptions: filterOptions,
      };
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
        isLoading: false,
      });
      dispatch(fetchTrainers(params));
      dispatch(fetchAllTotalTrainersDetails());
    }
    return () => {
      dispatch(restoreTrainerInitial());
    };
  }, [trainerActivated]);

  useEffect(() => {
    if (trainerDeactivated === true) {
      setloading(true);
      let params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: searchText,
        FilterOptions: filterOptions,
      };
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
        isLoading: false,
      });
      dispatch(fetchTrainers(params));
      dispatch(fetchAllTotalTrainersDetails());
    }
    return () => {
      dispatch(restoreTrainerInitial());
    };
  }, [trainerDeactivated]);

  //===>this is the useeffect handlling the API dispatch for pagination
  useEffect(() => {
    setloading(true);
    const params = {
      PageNumber: pageNumber,
      Search: searchText,
      FilterOptions: filterOptions,
    };
    dispatch(fetchTrainers(params));
    return () => {
      dispatch(restoreTrainerInitial());
    };
  }, [dispatch, filterOptions, pageNumber, searchText]);

  useEffect(() => {
    if (trainerUpdated === true) {
      let params = {};
      params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: searchText,
      };
      if (filterOptions.status !== "") {
        params["FilterOptions.Status"] = filterOptions.status;
      }
      if (filterOptions.zones !== "") {
        params["FilterOptions.Zone"] = filterOptions.zones;
      }
      if (
        filterOptions.states !== "" &&
        filterOptions.states !== 0 &&
        filterOptions.states !== undefined
      ) {
        params["FilterOptions.State"] = filterOptions.states;
      } else {
        delete params["FilterOptions.State"];
      }
      dispatch(fetchTrainers(params));
      handleCloseNewTrainerDialog();
      handleCloseViewTrainerDialog();
      return () => {
        dispatch(restoreTrainerInitial());
      };
    }
  }, [trainerUpdated]);

  // effect  used to populate table data
  useEffect(() => {
    if (trainersFetched.length === 0) {
      // setloading(false);
      setShowNoDataMessage(true);
      setTrainersTableData([]);
    } else if (
      trainersFetched.length !== 0 &&
      trainersFetched !== null &&
      trainersFetched !== undefined
    ) {
      const createTableData = () => {
        let trainersTableData = [];

        trainersFetched.map((trainer) => {
          if (trainer.approvalStatus !== "PhysicalVerificationApproved") {
            //const trainerLocation = `${trainer.lga}, ${trainer.state} State`;

            var skillNames = "";
            trainer.skills.map((skill) => (skillNames += `${skill.name},`));

            if (skillNames.length > 0) {
              skillNames = skillNames.slice(0, skillNames.length - 1);
            } else {
              skillNames = "-";
            }

            // const ownerData = trainer.trainers.find(
            //   (trainer) => trainer.isOwner === true
            // );

            // let ownerName = "";
            // if (ownerData === undefined) {
            //   ownerName = "-";
            // }
            //  else {
            //   ownerName = `${ownerData.firstName} ${ownerData.middleName} ${ownerData.lastName}`;
            // }

            var row = [
              trainer.skillCenterName,
              // skillNames,
              // ownerName,
              trainer.centerPhoneNumber,
              trainer.centerEmail,
              trainer.state,
              trainer.lga,
              trainer.approvalStatus,
              trainer,
              // trainerLocation,
              //trainerLocation,
            ];
            return trainersTableData.push(row);
          }

          return null;
        });
        setTrainersTableData(trainersTableData);
        // setloading(false);
        setShowNoDataMessage(true);
      };
      trainersFetched.length > 0 && createTableData();
    } else {
      setTrainersTableData([]);
    }

    return () => {
      setloading(false);
    };
  }, [trainersFetched, pageNumber]);

  const changePage = (page) => {
    setloading(true);
    setPageNumber(page);
  };

  useEffect(() => {
    if (
      isLoading === false &&
      // trainersFetched.length < 0 &&
      trainersFetched.length === 0
    ) {
      setShowNoDataMessage(true);
      setloading(false);
    } else {
      setShowNoDataMessage(true);
    }
  }, [isLoading, trainersFetched]);



  const paginationOptions = {
    selectableRows: "none",
    jumpToPage: true,
    serverSide: true,
    // count: trainersTableData.length,
    count: totalTrainerCount,
    page: pageNumber - 1,
    print: false,
    searchText: searchText,
    search: false,
    rowsPerPage: 10,
    rowsPerPageOptions: [10],
    viewColumns: false,

    onDownload: () => {
      if (!exportingVirtuallyApprovedTrainers) {
        dispatch(exportVirtuallyApprovedTrainers());
      }
      return false;
    },

    onSearchChange: (setSearch, param) => {
      dispatch(fetchTrainers(param));
    },
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setloading(true);
        changePage(tableState.page + 1);
        return () => {
          setloading(false);
        };
      }
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomToolbarSelect
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
      />
    ),
    disableRipple: true,
    filter: false,
    elevation: 0,
    filterType: "dropdown",
    responsive: "standard",
    fixedHeader: true,
    tableBodyMinHeight: "600px",
    tableBodyMaxHeight: "1000px",
    // print:false,
    // rowsPerPageOptions: [10, 50, 100],

    textLabels: {
      body: {
        noMatch: showNoDataMessage ? <EmptyRowIcon /> : "",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        // noMatch: <EmptyRowIcon /> ,
        // columnToolBarSelect: function()(selectedRows, displayData, selectedRows)=>void,
      },
      pagination: {
        next: "Next Page",
        previous: "Previous Page",
        rowsPerPage: "Rows per page:",
        displayRows: "of",
      },
      toolbar: {
        downloadCsv: "Download Excel Sheet",
        search: "Search",
        print: "Print page",
        viewColumns: "View columns",
        filterTable: "Filter table",
      },
      filter: {
        all: "All",
        title: "FILTERS",
        reset: "RESET",
      },
      viewColumns: {
        title: "Show Columns",
        titleAria: "Show/Hide Table Columns",
      },
      selectedRows: {
        text: "row(s) selected",
        delete: "Delete",
        deleteAria: "Delete Selected Rows",
      },
    },
  };

  function handleViewTrainingCenter(value) {
    navigate("/home/trainersmanagement/virtualApproval/approveTrainer");
    dispatch(saveCurrentTrainerId(value.id));
  }

  const columns = [
    {
      name: "skillAcquisitionCentre",
      label: "Training center Name",
      options: {
        setCellProps: () => ({
          style: { minWidth: "130px", paddingLeft: "20px" },
        }),

        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              <span style={{ marginLeft: "20px" }}>{column.label}</span>
            </Typography>
          );
        },
        customBodyRender: (value) => {
          return value === undefined || value === "" || value === null
            ? "null"
            : value;
        },
        filter: false,
      },
    },
    // {
    //   name: "skillNames",
    //   label: "Skill Set",
    //   options: {
    //     customHeadLabelRender: ({ index, ...column }) => {
    //       return (
    //         <Typography sx={ColumnTextStyle} key={index}>
    //           {column.label}
    //         </Typography>
    //       );
    //     },
    //   },
    // },
    // {
    //   name: "ownerName",
    //   label: "Owner Name",
    //   options: {
    //     setCellProps: () => ({
    //       style: { minWidth: "130px", paddingLeft: "20px" },
    //     }),

    //     customHeadLabelRender: ({ index, ...column }) => {
    //       return (
    //         <Typography sx={ColumnTextStyle} key={index}>
    //           <span style={{ marginLeft: "20px" }}>{column.label}</span>
    //         </Typography>
    //       );
    //     },
    //     customBodyRender: (value) => {
    //       return value === undefined || value === "" || value === null
    //         ? "null"
    //         : value;
    //     },
    //     filter: false,
    //   },
    // },
    {
      name: "centerPhoneNumber",
      label: "Phone Number",
      options: {
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "centerEmail",
      label: "Email Address",
      options: {
        setCellProps: () => ({ style: { minWidth: "120px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value) => {
          return value === undefined || value === "" || value === null
            ? "null"
            : value;
        },
        filter: false,
      },
    },
    {
      name: "state",
      label: "state",
      options: {
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "lga",
      label: "LGA",
      options: {
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "status",
      label: "Approval Status",
      options: {
        sort: false,
        setCellProps: () => ({ style: { minWidth: "100px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          switch (value) {
            case "Submitted":
              return (
                <StatusGenerator
                  statusText="Submitted"
                  variant="yellowFilled"
                />
              );
            case "StateOfficerApproved":
              return (
                <StatusGenerator
                  statusText="HOS Recommended"
                  variant="greenFilled"
                />
              );
            case "StateOfficerDisapproved":
              return (
                <StatusGenerator
                  statusText="HOS Unrecommended"
                  variant="redOutlined"
                />
              );
            case "StateCordinatorApproved":
              return (
                <StatusGenerator
                  statusText="SC Recommended"
                  variant="greenFilled"
                />
              );
            case "StateCordinatorDisapproved":
              return (
                <StatusGenerator
                  statusText="SC Unrecommended"
                  variant="redOutlined"
                />
              );
            case "HeadQuatersApproved":
              return (
                <StatusGenerator
                  statusText="HQ Approved"
                  variant="greenFilled"
                />
              );
            case "HeadQuatersDisapproved":
              return (
                <StatusGenerator
                  statusText="HQ Disapproved"
                  variant="redFilled"
                />
              );
            default:
              return "No status";
          }
        },
        filter: true,
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        sort: false,
        filterType: false,
        filter: false,
        setCellProps: () => ({ style: { minWidth: "100px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <Tooltip title={"View Trainer"}>
                <IconButton
                  size="small"
                  onClick={() => handleViewTrainingCenter(value)}
                >
                  <ViewIcon icon="material-symbols:visibility-outline" />
                </IconButton>
              </Tooltip>
              {/* <Tooltip title={"Edit Trainer"}>
                <IconButton size="small">
                  <EditIcon
                    icon="icon-park-outline:edit"
                    onClick={() => handleOpenEditTrainerDialog(value.id)}
                  />
                </IconButton>
              </Tooltip>
              {value.isActive === false ? (
                <Tooltip title={"Activate Trainer"}>
                  <IconButton
                    size="small"
                    onClick={() =>
                      setConfirmDialog({
                        isOpen: true,
                        title: `Are you sure you want to activate ${
                          value.firstName + " " + value.lastName
                        }?`,
                        header: `Activate ${
                          value.firstName + " " + value.lastName
                        }`,
                        // backgroundColor: colors.successDialogBg,
                        // borderSideColor: colors.darkSuccessDialog,
                        color: colors.primaryGreen,
                        subColor: colors.successDialogSubTitle,
                        onConfirm: () => {
                          activateTrainerHandler(value.id);
                        },
                      })
                    }
                  >
                    <ActivateIcon icon="fluent-mdl2:activate-orders" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={"Deactivate Trainer"}>
                  <IconButton
                    size="small"
                    onClick={() =>
                      setConfirmDialog({
                        isOpen: true,
                        title: `Are you sure you want to deactivate ${
                          value.firstName + " " + value.lastName
                        }?`,
                        header: `Deactivate ${
                          value.firstName + " " + value.lastName
                        }`,
                        // backgroundColor: colors.successDialogBg,
                        // borderSideColor: colors.darkSuccessDialog,
                        color: colors.primaryGreen,
                        subColor: colors.successDialogSubTitle,
                        onConfirm: () => {
                          deactivateTrainerHandler(value.id);
                        },
                      })
                    }
                  >
                    <DeactivateIcon icon="fluent-mdl2:deactivate-orders" />
                  </IconButton>
                </Tooltip>
              )} */}
            </>
          );
        },
      },
    },
  ];

  const displayData = [
    { status: true },
    { status: false },
    { status: true },
    { status: false },
  ];

  const trainersTableComponents = {
    icons: {
      DownloadIcon,
    },
  };

  const handleChange = (e) => {
    let searchValue = e.target.value;
    setSearchText(searchValue);
  };

  const CustomToolbarSelect = () => {
    const handleClickArchive = () => {
      // this.props.setSelectedRows([]);
    };

    return (
      <div style={{ marginRight: " 24px" }}>
        <Tooltip title={`Archive Trainers`}>
          <IconButton onClick={handleClickArchive}>
            <ArchiveIcon />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  return (
    <Page title="SAED | Trainer Set-up">
      <Container maxWidth="xl">
        <Box sx={{ pb: 2 }}>
          <Typography
            variant="h5"
            style={{ fontWeight: 600, color: "#212B36" }}
          >
            Trainers Management &gt; Virtual Approval
          </Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box>
              <Paper
                sx={{
                  boxShadow: "0 1px 2px 0 rgb(145 158 171 / 24%)",
                  borderRadius: "20px",
                }}
              >
                <Card
                  elevation={0}
                  sx={{ padding: "0px !important", borderRadius: "20px" }}
                >
                  <CardContent sx={{ padding: "0px !important" }}>
                    <ThemeProvider theme={MuiDataTableTheme}>
                      <LoadingOverlay
                        active={loading}
                        styles={{
                          overlay: (base) => ({
                            ...base,
                            background: "rgba(0, 0, 0, 0.15)",
                          }),
                        }}
                        spinner
                        text="Fetching Data for You..."
                      >
                        <MUIDataTable
                          title={
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={10}
                              justifyContent="space-between"
                            >
                              <Typography
                                sx={{ color: "#05004E", fontWeight: 600 }}
                              >
                                Training Centres Pending Recommendation
                              </Typography>
                              <Searchbox
                                placeholder="Training Center"
                                onChange={handleChange}
                                value={searchText}
                              />
                            </Box>
                          }
                          data={trainersTableData}
                          columns={columns}
                          options={paginationOptions}
                          displayData={displayData}
                          components={trainersTableComponents}
                          style={{ transition: "0.7s" }}
                        />
                      </LoadingOverlay>
                    </ThemeProvider>
                  </CardContent>
                </Card>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <div id="printarea" style={{ display: "none" }}>
        <TrainersPrintTemplate />
      </div>
      <DialogBox openDialog={openDialog} setOpenDialog={setOpenDialog} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
      <ToastContainer theme="dark" toastStyle={ToastStyle} />
    </Page>
  );
};

export default VirtualApproval;
